/*
 * @Author: bbqin
 * @Date: 2023-02-15 10:28:51
 * @LastEditTime: 2023-07-06 10:16:52
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\card\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import { BaseComponent } from '@platform/template';
import { getSysFieldid } from '@platform/api';
import Load from './load';
require('./index.less');

const defaultProps = {
    prefixCls: 'single-card',
    visible: true,
    fieldid: 'smart_card_part',
};

class SingleCard extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, id } = props;
        // store.setStore('id', id, false);
    }

    componentWillUnMount() {
        // 销毁挂在主store上的当前store对象
        const { store, parentStore } = this.props;
    }

    getEmptyContent(emptyContent) {
        const { __langJson = {}, prefixCls } = this.props;
        const dom = <div className={`${prefixCls}-empty-content`}>
            <i className={`${prefixCls}-empty-img`}></i>
            <span>{__langJson['card-empty-content']}</span>
        </div>;
        return <div className={`${prefixCls}-empty`}>
            {typeof emptyContent === 'function' ? emptyContent() : dom}
        </div>;
    }

    getCard() {
        let {
            pageInstance,
            path,
            store,
            __componentName,
            __langJson,
            prefixCls,
            // 某些组件的特殊属性
            customConfigPanel,
            smartCardModuleId,
            componentNameSpace,
            feedbackMessage,
            getPageInstanceByPortal,
            portalPageInstance,
        } = this.props;
        let currentProps = store.getCardProps();
        const { visible, emptyContent } = currentProps;
        if (!visible) {
            return null;
        }

        // 嵌入式分析
        if (path === 'LowCodeComponents.NCEmbedGraphic') {
            componentNameSpace = 'embedGraphic';
            path = '../../../../lappreportrt/embedGraphic/embedGraphic.js';
        }

        if (!path) {
            return this.getEmptyContent(emptyContent);
        } else {
            return <Load
                path={path}
                componentNameSpace={componentNameSpace}
                pageInstance={pageInstance}
                getInstance={instance => {
                    store.setStore('cardInstance', instance, false);
                }}
                __langJson={__langJson}
                __componentName={__componentName}
                smartCardModuleId={smartCardModuleId}
                feedbackMessage={feedbackMessage}
                getParentPageInstance={getPageInstanceByPortal}
                portalPageInstance={portalPageInstance}
                {...currentProps}
            ></Load>;
        }
    }

    render() {
        let { prefixCls, fieldid, id } = this.props;
        return <div className={`${prefixCls}-wrapper`} id={`SingleCard_${id || ''}`} fieldid={getSysFieldid(`${id || ''}_${fieldid}`)} >{this.getCard()}</div>;
    }
}

SingleCard.defaultProps = defaultProps;
SingleCard.displayName = 'SingleCard';

export default SingleCard;
